import { render, staticRenderFns } from "./SidebarNavTitle.vue?vue&type=template&id=2fbd6adb&"
import script from "./SidebarNavTitle.vue?vue&type=script&lang=js&"
export * from "./SidebarNavTitle.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNavTitle.vue?vue&type=style&index=0&id=2fbd6adb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports